import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnGroup } from 'react-table';

import i18next from 'i18next';

import { formatDate } from 'helpers/formatDate';

import * as S from './List.styles';
import { ActionsDropdown } from './components/ActionsDropdown';

export const useColumns = () => {
  const { t } = useTranslation();

  return useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Orders',
        columns: [
          {
            Header: '#',
            accessor: 'orderNumber',
          },
          {
            Header: t('customer.label')!,
            accessor: 'customerCode',
            Cell: ({ row }) => (
              <S.CustomerName>
                {row.original.customerCode}
                {row.original.customerName && ` — ${row.original.customerName}`}
              </S.CustomerName>
            ),
          },
          {
            Header: t('common.date')!,
            accessor: 'date',
            Cell: ({ value }) => <>{formatDate(value)}</>,
          },
          {
            Header: t('nav.catalogue')!,
            disableSortBy: true,
            accessor: 'catalogues',
            Cell: ({ value }) => (
              <S.StickerBox>
                {value?.map((item: string) => (
                  <S.Sticker key={item}>{item}</S.Sticker>
                ))}
              </S.StickerBox>
            ),
          },
          {
            Header: t('catalogue.gender')!,
            disableSortBy: true,
            accessor: 'genders',
            Cell: ({ value }) => (
              <S.GenderBox>
                {value?.map((item: string) => (
                  <S.Sticker key={item}>{item}</S.Sticker>
                ))}
              </S.GenderBox>
            ),
          },
          {
            Header: t('common.status')!,
            accessor: 'status',
            Cell: ({ value }) => (
              <S.Sticker isGreen={value === 'SEND'} key={value}>
                {String(t(`status.${value}` as any))}
              </S.Sticker>
            ),
          },
          {
            Header: ' ',
            accessor: 'actions',
            disableSortBy: true,
            Cell: ({ row }) => (
              <ActionsDropdown
                status={row.original.status}
                orderId={row.original.orderId}
                orderNumber={String(row.original.orderNumber)}
                customerCode={row.original.customerCode}
                customerName={row.original.customerName}
              />
            ),
          },
        ],
      },
    ],
    [i18next.language]
  );
};
